import { createContext, useContext } from "react";

type ThemeContextType = {
  isDarkMode: boolean;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    return { isDarkMode: false };
  }
  return context;
}
